import "whatwg-fetch"; // polyfill for older browsers

import { getAPIConfig } from "@utils/browser-helpers";
import { getJWT } from "@utils/browser-helpers";

export default {
  fetchConsoleConfig: (isCommercial = false) => {
    const apiConfig = getAPIConfig(
      isCommercial
        ? `/commercial/${getJWT().ctid}/console_config`
        : "/console_config",
      !isCommercial
    );

    let headers = {
      "Content-Type": "application/json",
      Authorization: "SYF " + apiConfig.jwtToken,
    };

    return fetch(apiConfig.url, {
      headers: headers,
      method: "GET",
      dataType: "json",
    })
      .then((response) => response.json())
      .then((json) => {
        window.timeZone = "America/New_York";
        return {
          timeZone: "America/New_York",
          bannerScriptTypes: (json || {}).banner_script_types,
          bannerImageTypes: (json || {}).banner_image_types,
          actionTypeSectionValues: (json || {}).action_sections || [],
          segmentationEnabled: true,
          promotionSupEnabled:
            (json || {}).promotion_supplemental_enabled || "",
          notificationScriptTypes: (json || {}).notification_script_types,
          appSettings: (json || {}).app_config,
          pureResponse: json,
        };
      })
      .catch((err) => {
        console.error("Error fetching consoleConfig:", err);
        return null;
      });
  },
};
